import React from "react";
import RichTextEditor from "../../../components/RichTextEditor";

export default function LegalTab({ settings, setSettings, saveLegal }) {
  return (
    <section className="card-surface p-5 sm:p-8" data-testid="legal-section">
      <h2 className="font-serif text-xl sm:text-2xl mb-2">Termeni & Confidentialitate</h2>
      <p className="text-xs mb-6" style={{ color: "var(--brand-text-secondary)" }}>
        Continutul paginilor publice <code>/termeni</code> si <code>/confidentialitate</code>. Editor rich-text — formatare, liste, link-uri, titluri.
      </p>

      <div className="grid lg:grid-cols-2 gap-6">
        <div>
          <label className="label-eyebrow block mb-2">Termeni si conditii — RO</label>
          <RichTextEditor value={settings.legal?.terms_ro || ""} onChange={(html) => setSettings({...settings, legal: {...(settings.legal||{}), terms_ro: html}})} placeholder="Scrie aici termenii in romana..." testid="legal-terms-ro" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Terms — EN</label>
          <RichTextEditor value={settings.legal?.terms_en || ""} onChange={(html) => setSettings({...settings, legal: {...(settings.legal||{}), terms_en: html}})} placeholder="English terms..." testid="legal-terms-en" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Politica de confidentialitate — RO</label>
          <RichTextEditor value={settings.legal?.privacy_ro || ""} onChange={(html) => setSettings({...settings, legal: {...(settings.legal||{}), privacy_ro: html}})} placeholder="Politica de confidentialitate..." testid="legal-privacy-ro" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Privacy Policy — EN</label>
          <RichTextEditor value={settings.legal?.privacy_en || ""} onChange={(html) => setSettings({...settings, legal: {...(settings.legal||{}), privacy_en: html}})} placeholder="Privacy policy in English..." testid="legal-privacy-en" />
        </div>
      </div>
      <button onClick={saveLegal} className="btn-gold-filled mt-6" data-testid="save-legal">Salveaza Legal</button>
    </section>
  );
}
